import React from "react";
import { Order, Product, OrderItem } from "../../interfaces/orders_manage";
import './InvoicePrint.css'

interface EnrichedOrder extends Order {
  items: (OrderItem & {
    product?: Product;
  })[];
}

interface Props {
  order: EnrichedOrder;
}

export const InvoicePrint: React.FC<Props> = ({ order }) => {

  let subtotal = 0;
  let totalGST = 0;

  const items = order.items.map((item, i) => {
    const price = item.price ?? 0;
    const qty = item.quantity ?? 0;
    const gst = item.product?.gst ?? 0;

    const total = price * qty;
    const gstAmount = (total * gst) / 100;

    subtotal += total;
    totalGST += gstAmount;

    return {
      ...item,
      total,
      gstAmount,
      index: i + 1
    };
  });

  const cgst = totalGST / 2;
  const sgst = totalGST / 2;
  const grandTotal = subtotal + totalGST;

  return (
  <div className="invoice-wrapper">

    {/* Header */}
    <div className="invoice-header">
      <div>
        <h1 className="invoice-title">TAX INVOICE</h1>
        <p className="invoice-sub">Order Receipt</p>
      </div>

      <div className="invoice-meta">
        <p><strong>Order ID</strong></p>
        <p>{order.id}</p>
        <p><strong>Date</strong></p>
        <p>{new Date(order.createdAt).toLocaleDateString()}</p>
      </div>
    </div>

    {/* Divider */}
    <div className="divider" />

    {/* Table */}
    <table className="invoice-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Description</th>
          <th>Qty</th>
          <th>Rate</th>
          <th>GST</th>
          <th>Amount</th>
        </tr>
      </thead>

      <tbody>
        {items.map(item => (
          <tr key={item.id}>
            <td>{item.index}</td>
            <td className="desc">{item.productName}</td>
            <td>{item.quantity}</td>
            <td>₹ {item.price.toFixed(2)}</td>
            <td>{item.product?.gst ?? 0}%</td>
            <td className="amount">₹ {item.total.toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* Totals */}
    <div className="totals-wrapper">
      <div className="totals-card">

        <div className="totals-row">
          <span>Subtotal</span>
          <span>₹ {subtotal.toFixed(2)}</span>
        </div>

        <div className="totals-row">
          <span>CGST</span>
          <span>₹ {cgst.toFixed(2)}</span>
        </div>

        <div className="totals-row">
          <span>SGST</span>
          <span>₹ {sgst.toFixed(2)}</span>
        </div>

        <div className="totals-divider" />

        <div className="totals-row grand">
          <span>Total</span>
          <span>₹ {grandTotal.toFixed(2)}</span>
        </div>

      </div>
    </div>

  </div>
);

};
